import { render, staticRenderFns } from "./CRReport.vue?vue&type=template&id=37c6d46c&"
import script from "./CRReport.vue?vue&type=script&lang=js&"
export * from "./CRReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports